import type { SessionStepDto } from '../../schemas/sessionSchemas';

/**
 * The Document Template step. Matched on step type alone — unlike the verification
 * steps, whose display names vary, this one is only ever created by the builder's
 * Document Template tile.
 */
export function isTemplateStep(step: SessionStepDto): boolean {
  return step.stepType === 'document_template';
}
